import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import SetProposalReminder from "./SetProposalReminder";
import AddTemplate from "./AddTemplate";
import Table from "../../../../../core/pagination/datatable";
import dayjs from "dayjs";
import { BASE_CRM_URL } from "../../../../components/config/config";
import Swal from "sweetalert2";
import {
  Select as TagSelector,
  Spin,
  Empty,
  Input,
  DatePicker,
  Drawer,
  Button,
  Card,
  Divider,
} from "antd";
import { CalendarOutlined } from "@ant-design/icons";
import { CloseOutlined } from "@ant-design/icons";
import { EditOutlined } from "@ant-design/icons";
const ProposalInfo = () => {
  const [terms, setTerms] = useState(`
1. Warranty: 12 months from the date of installation. Materials are not covered if they fail due to power fluctuations, accidents, physical damage, or water damage.

2. Devices once installed or used will not be taken back (No Refund).

3. Devices must be sent to our company for verification and to address any hardware-related issues. Otherwise, technician pickup charges are applicable.

4. LAN/Wi-Fi connectivity must be provided by the customer.

5. Perennial Code will provide service only. In case of any spare replacement, the customer has to bear the cost.

6. Delivery: 2–3 working days from the date of payment.

7. Site visits are not covered under AMC and are chargeable.`);
  const [activeTab, setActiveTab] = useState("proposal");
  
  const taskColumns = [
    { title: "#" },
    { title: "Name" },
    { title: "Status" },
    { title: "Start Date" },
    { title: "Due Date" },
    { title: "Assigned To" },
    { title: "Tags" },
    { title: "Priority" },
  ];
  const userDetails = JSON.parse(sessionStorage.getItem("userDetails"));
  const userId = userDetails?.staffid;

  const { id } = useParams();

  console.log(id, "idddddddddddddddddd"); // e.g. 2

  const getProposalStatus = (status) => {
    switch (status) {
      case 1:
        return "Draft";
      case 2:
        return "Sent";
      case 3:
        return "Open";
      case 4:
        return "Revised";
      case 5:
        return "Declined";
      case 6:
        return "Accepted";
      default:
        return "Unknown";
    }
  };

  const [proposalDetails, setProposalDetails] = useState(null);

  console.log(proposalDetails, "proposaldetailsssssssssssssssss");

  const getProposal = async (id) => {
    try {
      const response = await fetch(`${BASE_CRM_URL}proposal/GetProposal/${id}`);

      const data = await response.json();

      setProposalDetails(data);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    getProposal(id);
  }, []);

  // reminders code for proposal

  const [reminders, setReminders] = useState([]);
  const [remindersLoading, setRemindersLoading] = useState(false);

  const [addReminderLoading, setAddReminderLoading] = useState(false);
  const [updateReminderLoading, setUpdateReminderLoading] = useState(false);

  const [editingReminderId, setEditingReminderId] = useState(null);

  const [reminderData, setReminderData] = useState({
    description: "",
    date: null,
    staff: userId,
  });

  const [editReminderData, setEditReminderData] = useState({
    description: "",
    date: null,
    staff: userId,
  });

  const [staffList, setStaffList] = useState([]);
  const [staffLoading, setStaffLoading] = useState(false);

  const fetchReminders = async () => {
    try {
      setRemindersLoading(true);

      const response = await fetch(
        `${BASE_CRM_URL}reminder/GetReminders?rel_id=${id}&rel_type=Proposal&staffid=0`
      );

      const data = await response.json();

      if (data.Status) {
        setReminders(data.ResultData || []);
      } else {
        setReminders([]);
      }
    } catch (error) {
      console.error(error);
      setReminders([]);
    } finally {
      setRemindersLoading(false);
    }
  };

  const fetchStaff = async () => {
    try {
      setStaffLoading(true);

      const response = await fetch(`${BASE_CRM_URL}staff/GetStaffDropdown`);
      const data = await response.json();

      if (data.ResultData) {
        setStaffList(data.ResultData);
      } else {
        setStaffList([]);
      }
    } catch (error) {
      console.error("Error fetching staff:", error);
      setStaffList([]);
    } finally {
      setStaffLoading(false);
    }
  };
  const handleAddReminder = async () => {
    if (!reminderData.description.trim()) {
      Swal.fire({
        icon: "warning",
        title: "Description Required",
        text: "Please enter reminder description.",
      });
      return;
    }

    if (!reminderData.date) {
      Swal.fire({
        icon: "warning",
        title: "Reminder Date Required",
        text: "Please select reminder date.",
      });
      return;
    }

    try {
      setAddReminderLoading(true);
      const userDetails = JSON.parse(sessionStorage.getItem("userDetails"));
      const userId = userDetails?.staffid;
      const response = await fetch(`${BASE_CRM_URL}reminder/AddReminder`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          description: reminderData.description,
          date: dayjs(reminderData.date).format("YYYY-MM-DD HH:mm:ss"),
          rel_id: id,
          rel_type: "Proposal",
          staff: reminderData.staff,
          creator: userId,
        }),
      });

      const data = await response.json();

      if (data.Status) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: data.Message,
          timer: 1500,
          showConfirmButton: false,
        });

        setReminderData({
          description: "",
          date: null,
          staff: userId,
        });

        fetchReminders();
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: data.Message,
        });
      }
    } catch (error) {
      console.error(error);

      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Something went wrong.",
      });
    } finally {
      setAddReminderLoading(false);
    }
  };

  const handleEditReminder = (reminder) => {
    setEditingReminderId(reminder.id);

    setEditReminderData({
      description: reminder.description,
      date: dayjs(reminder.date),
      staff: reminder.staff,
    });
  };

  const handleCancelReminderEdit = () => {
    setEditingReminderId(null);

    setEditReminderData({
      description: "",
      date: null,
      staff: userId,
    });
  };

  const handleUpdateReminder = async () => {
    if (!editReminderData.description.trim()) {
      Swal.fire({
        icon: "warning",
        title: "Description Required",
        text: "Please enter reminder description.",
      });
      return;
    }

    try {
      setUpdateReminderLoading(true);

      const response = await fetch(`${BASE_CRM_URL}reminder/UpdateReminder`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: editingReminderId,
          description: editReminderData.description,
          date: dayjs(editReminderData.date).format("YYYY-MM-DD HH:mm:ss"),
          staff: editReminderData.staff,
        }),
      });

      const data = await response.json();

      if (data.Status) {
        Swal.fire({
          icon: "success",
          title: "Updated",
          text: data.Message,
          timer: 1500,
          showConfirmButton: false,
        });

        setEditingReminderId(null);

        fetchReminders();
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: data.Message,
        });
      }
    } catch (error) {
      console.error(error);

      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Something went wrong.",
      });
    } finally {
      setUpdateReminderLoading(false);
    }
  };

  useEffect(() => {
    fetchReminders();
    fetchStaff();
  }, []);

  //notes tab integration

  const [notes, setNotes] = useState([]);
  const [notesLoading, setNotesLoading] = useState(false);
  const [addNoteLoading, setAddNoteLoading] = useState(false);
  const [noteData, setNoteData] = useState({
    description: "",
    date_contacted: null,
  });
  const [editingNoteId, setEditingNoteId] = useState(null);
  const [editNoteData, setEditNoteData] = useState({
    description: "",
  });
  const [updateNoteLoading, setUpdateNoteLoading] = useState(false);

  const fetchNotes = async () => {
    try {
      setNotesLoading(true);

      const response = await fetch(
        `${BASE_CRM_URL}notes/GetNotes?rel_id=${id}&rel_type=Proposal`
      );

      const data = await response.json();

      if (data.Status) {
        setNotes(data.ResultData || []);
      } else {
        setNotes([]);
      }
    } catch (error) {
      console.error("Error fetching notes:", error);
      setNotes([]);
    } finally {
      setNotesLoading(false);
    }
  };

  const handleEditNote = (note) => {
    setEditingNoteId(note.id);

    setEditNoteData({
      description: note.description,
    });
  };

  const handleUpdateNote = async () => {
    if (!editNoteData.description.trim()) {
      Swal.fire({
        icon: "error",
        title: "Please enter a note.",
      });
      return;
    }

    try {
      setUpdateNoteLoading(true);

      const response = await fetch(`${BASE_CRM_URL}notes/UpdateNote`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: editingNoteId,
          description: editNoteData.description,
        }),
      });

      const data = await response.json();

      if (data.Status) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: data.Message,
          timer: 2000,
          showConfirmButton: false,
        });

        setEditingNoteId(null);

        setEditNoteData({
          description: "",
        });

        fetchNotes();
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: data.Message,
        });
      }
    } catch (error) {
      console.error(error);
    } finally {
      setUpdateNoteLoading(false);
    }
  };

  const handleCancelEdit = () => {
    setEditingNoteId(null);

    setEditNoteData({
      description: "",
    });
  };

  const handleAddNote = async () => {
    if (!noteData.description.trim()) {
      Swal.fire({
        icon: "error",
        title: "Please enter a note.",
      });
      return;
    }

    try {
      setAddNoteLoading(true);
      const userDetails = JSON.parse(sessionStorage.getItem("userDetails"));
      const userId = userDetails?.staffid;
      const response = await fetch(`${BASE_CRM_URL}notes/AddNote`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          rel_id: id,
          rel_type: "Proposal",
          description: noteData.description,
          addedfrom: userId,
        }),
      });

      const data = await response.json();

      if (data.Status) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: data.Message,
          timer: 2000,
          showConfirmButton: false,
        });

        setNoteData({
          description: "",
          date_contacted: null,
        });

        fetchNotes();
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: data.Message,
        });
      }
    } catch (error) {
      console.error(error);
    } finally {
      setAddNoteLoading(false);
    }
  };

  useEffect(() => {
    fetchNotes();
  }, []);

  const [noteDrawerOpen, setNoteDrawerOpen] = useState(false);


  
  const [reminderDrawerOpen, setReminderDrawerOpen] = useState(false);
  const handleCloseReminderDrawer = () => {
    setReminderDrawerOpen(false);
    setEditingReminderId(null);

    setReminderData({
      description: "",
      date: null,
      staff: null,
    });

    setEditReminderData({
      description: "",
      date: null,
      staff: null,
    });
  };

  // task integration
  const [tasks, setTasks] = useState([]);
  const [taskLoading, setTaskLoading] = useState(false);

  const getTasks = async () => {
    try {
      setTaskLoading(true);

      const response = await fetch(
        `${BASE_CRM_URL}tasks/GetTasksnew?leadId=&customerId=&salesId=&expenseId=&proposalId=${id}&invoiceId=`
      );

      const data = await response.json();

      if (data.Status) {
        setTasks(data.ResultData || []);
      } else {
        setTasks([]);
      }
    } catch (error) {
      console.error("Error fetching tasks:", error);
      setTasks([]);
    } finally {
      setTaskLoading(false);
    }
  };

  useEffect(() => {
    if (id) {
      getTasks();
    }
  }, [id]);

  return (
    <>
    <style>{`
    .proposal-summary .border-end {
      border-right: 1px solid #dee2e6 !important;
    }`}</style>
      <div className="page-wrapper">
        <div className="content pt-2">
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb d-flex justify-content-between w-100">
              <div className="d-flex align-items-center">
                <li className="breadcrumb-item">
                  <Link to="/crm/dashboard">
                    <i className="fas fa-home fa-lg" />
                  </Link>
                </li>
                <h4 className="breadcrumb-item mb-0" aria-current="page">
                  Proposal Info
                </h4>
              </div>
              {/* <div className="d-flex align-items-center">
                <h4>PRO-2345</h4>
              </div> */}

              <ul
                className="nav nav-tabs nav-tabs-bottom "
                id="myTab"
                role="tablist"
              >
                <li className="nav-item" role="presentation">
                  <Link
                    className={`nav-link ${
                      activeTab === "proposal" ? "active" : ""
                    }`}
                    id="proposal-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#proposal-tab-pane"
                    type="button"
                    role="tab"
                    aria-controls="proposal-tab-pane"
                    aria-selected={activeTab === "proposal"}
                    onClick={() => setActiveTab("proposal")}
                  >
                    Proposal
                  </Link>
                </li>

                {/* <li className="nav-item" role="presentation">
                  <Link
                    className={`nav-link ${
                      activeTab === "reminders" ? "active" : ""
                    }`}
                    id="reminders-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#reminders-tab-pane"
                    type="button"
                    role="tab"
                    aria-controls="reminders-tab-pane"
                    aria-selected={activeTab === "reminders"}
                    onClick={() => setActiveTab("reminders")}
                  >
                    Reminders
                  </Link>
                </li> */}
                <li className="nav-item" role="presentation">
                  <Link
                    className={`nav-link ${
                      activeTab === "tasks" ? "active" : ""
                    }`}
                    id="tasks-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#tasks-tab-pane"
                    type="button"
                    role="tab"
                    aria-controls="tasks-tab-pane"
                    aria-selected={activeTab === "tasks"}
                    onClick={() => setActiveTab("tasks")}
                  >
                    Tasks
                  </Link>
                </li>
                <li className="nav-item" role="presentation">
                  <Link
                    to="#"
                    className="nav-link"
                    onClick={(e) => {
                      e.preventDefault();
                      setReminderDrawerOpen(true);
                    }}
                  >
                    Reminders
                  </Link>
                </li>

                {/* <li className="nav-item" role="presentation">
                  <Link
                    className={`nav-link ${
                      activeTab === "notes" ? "active" : ""
                    }`}
                    id="notes-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#notes-tab-pane"
                    type="button"
                    role="tab"
                    aria-controls="notes-tab-pane"
                    aria-selected={activeTab === "notes"}
                    onClick={() => setActiveTab("notes")}
                  >
                    Notes
                  </Link>
                </li> */}
                <li className="nav-item" role="presentation">
                  <Link
                    to="#"
                    className="nav-link"
                    onClick={(e) => {
                      e.preventDefault();
                      setNoteDrawerOpen(true);
                    }}
                  >
                    Notes
                  </Link>
                </li>

                {/* <li className="nav-item" role="presentation">
                    <Link
                      className={`nav-link ${
                        activeTab === "mail" ? "active" : ""
                      }`}
                      id="mail-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#mail-tab-pane"
                      type="button"
                      role="tab"
                      aria-controls="mail-tab-pane"
                      aria-selected={activeTab === "mail"}
                      onClick={() => setActiveTab("mail")}
                    >
                      <i className="fas fa-envelope"></i>
                    </Link>
                  </li> */}
              </ul>

              <div className="page-btn d-flex justify-content-between align-items-center flex-wrap gap-2">
                {/* Left Side */}
                <span
                  className="badge  bg-success px-3 py-2 g-2"
                  // style={{ backgroundColor: "#90EE90", color: "#fff" }}
                >
                  Active
                </span>

                {/* Right Side */}
                <div className="d-flex align-items-center gap-2">
                  <Link className="btn btn-info btn-sm">
                    <i className="fas fa-envelope"></i>
                  </Link>

                  <Link className="btn btn-soft-primary btn-sm">
                    More <i className="fas fa-chevron-down ms-1"></i>
                  </Link>

                  <Link className="btn btn-soft-danger btn-sm">
                    Convert <i className="fas fa-chevron-down ms-1"></i>
                  </Link>

                  <Link to="/crm/proposals" className="btn btn-dark btn-sm">
                    <i className="ti ti-arrow-left"></i>
                  </Link>
                </div>
              </div>
            </ol>
          </nav>

          <div className="container-fluid">
            <div className="card shadow proposal-summary">
              <div className="card-body pb-1 ">
                <div className="row align-items-center">
                  <div className="col-md-3 col-sm-6 mb-2 border-end text-center">
                    <div className="d-inline-flex align-items-center">
                      <span className="fw-bold me-2">Proposal No:</span>
                      <span className="fw-bold text-danger">
                        {/* {proposalDetails?.Proposal.number} */}
                      </span>
                    </div>
                  </div>

                  <div className="col-md-3 col-sm-6 mb-2 border-end text-center">
                    <div className="d-inline-flex align-items-center">
                      <i className="fa-regular fa-calendar me-2"></i>
                      <span className="fw-bold me-2">Issued On:</span>
                      <span className="fw-bold">
                        {dayjs(proposalDetails?.Proposal.datecreated).format(
                          "DD-MM-YYYY"
                        )}
                      </span>
                    </div>
                  </div>

                  <div className="col-md-3 col-sm-6 mb-2 border-end text-center">
                    <div className="d-inline-flex align-items-center">
                      <i className="fa-regular fa-clock  me-2"></i>
                      <span className="fw-bold me-2">Valid Until:</span>
                      <span className="fw-bold">
                        {dayjs(proposalDetails?.Proposal.open_till).format(
                          "DD-MM-YYYY"
                        )}
                      </span>
                    </div>
                  </div>

                  <div className="col-md-3 col-sm-6 mb-2 text-center">
                    <div className="d-inline-flex align-items-center">
                      <i className="fa-solid fa-indian-rupee-sign me-2"></i>
                      <span className="fw-bold me-2">Total:</span>
                      <span className="fw-bold text-success">
                        ₹{" "}
                        {Number(
                          proposalDetails?.Proposal.total
                        ).toLocaleString()}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="card shadow">
              <div className="card-body pt-0">
                <div className="tab-content " id="myTabContent">
                  <div
                    className={`tab-pane fade  ${
                      activeTab === "proposal" ? "show active" : ""
                    }`}
                    id="proposal-tab-pane"
                    role="tabpanel"
                    aria-labelledby="proposal-tab"
                  >
                    <div className="row">
                      <div className="col-12">
                        <div className="card-body">
                          <div className="row">
                            {/* Company Info */}
                            <div className="col-5">
                              <h6 className=" fw-bold mb-3">
                                <i className="fa-solid fa-building me-2"></i>
                                Perennial Code IT Consultants Pvt. Ltd.
                              </h6>

                              {/* <p className="mb-1">
                                <i className="fa-solid fa-location-dot  me-2"></i>
                               
                              </p> */}

                              <p className="mb-1">
                                <i className="fa-solid fa-map-location-dot  me-2"></i>
                                Vidya Nagar, Hyderabad, Telangana, INDIA -
                                500044
                              </p>

                              {/* <p className="mb-1">
                                <i className="fa-solid fa-earth-asia  me-2"></i>
                               
                              </p> */}

                              <p className="mb-1">
                                <i className="fa-solid fa-file-invoice  me-2"></i>
                                GSTIN: 36AAHCP3604R1ZM
                              </p>

                              <p className="mb-0">
                                <i className="fa-solid fa-phone-volume  me-2"></i>
                                +91 4048513363, +91 8297230010
                              </p>
                            </div>

                            <div className="col-3 d-flex justify-content-start align-items-end">
                              <div className="text-start">
                                <p className="mb-0">
                                  <i className="fa-solid fa-user-check me-2"></i>
                                  <strong>Assigned:</strong>{" "}
                                  {proposalDetails?.Proposal.AddedByName}
                                </p>
                              </div>
                            </div>

                            {/* Proposal Information */}
                            <div className="col-4 d-flex justify-content-end">
                              <div className="text-end">
                                <h6 className=" fw-bold mb-3">
                                  Proposal Information
                                </h6>

                                <p className="mb-2 fw-semibold">
                                  <i className="fa-solid fa-user-tie  me-2"></i>
                                  {proposalDetails?.Proposal.proposal_to}
                                </p>

                                {/* <p className="mb-2">
                                  <i className="fa-solid fa-location-dot  me-2"></i>
                                  {proposalDetails?.Proposal.address}
                                </p> */}

                                <p className="mb-2">
                                  <i className="fa-solid fa-city  me-2"></i>
                                  {proposalDetails?.Proposal.address},{" "}
                                  {proposalDetails?.Proposal.city},{" "}
                                  {proposalDetails?.Proposal.state} -{" "}
                                  {proposalDetails?.Proposal.zip}
                                </p>

                                <p className="mb-2">
                                  <i className="fa-solid fa-phone  me-2"></i>
                                  {proposalDetails?.Proposal.phone},{" "}
                                  <i className="fa-solid fa-envelope  me-2"></i>
                                  {proposalDetails?.Proposal.email}
                                </p>

                                {/* <p className="mb-0">
                                  <i className="fa-solid fa-envelope  me-2"></i>
                                  {proposalDetails?.Proposal.email}
                                </p> */}
                              </div>
                            </div>

                            {/* Summary Card */}
                            <div className="card border-0 shadow-sm mt-4 d-none">
                              <div className="card-body">
                                <h4 className="text-primary fw-bold mb-3">
                                  <i className="fa-solid fa-indian-rupee-sign me-2"></i>
                                  {Number(
                                    proposalDetails?.Proposal.total
                                  ).toLocaleString()}
                                </h4>

                                <div className="d-flex justify-content-between align-items-center mb-3">
                                  <span>
                                    <i className="fa-solid fa-circle-check text-success me-2"></i>
                                    Status
                                  </span>

                                  <span className="badge bg-soft-info px-3 py-2">
                                    {getProposalStatus(
                                      proposalDetails?.Proposal.status
                                    )}
                                  </span>
                                </div>

                                <hr />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* Table on the left */}
                      <div className="col-12">
                        <div className="card p-3 mb-3">
                          <div className="table-responsive">
                            <table className="table table-bordered table-hover align-middle mb-0">
                              <thead className="table-primary">
                                <tr>
                                  <th style={{ width: 60 }}>#</th>
                                  <th>Item</th>
                                  <th className="text-center">Qty</th>
                                  <th className="text-end">Rate</th>
                                  <th className="text-end">Tax</th>
                                  <th className="text-end">Amount</th>
                                </tr>
                              </thead>
                              <tbody>
                                {proposalDetails?.ItemDetails?.map(
                                  (item, index) => {
                                    const amount =
                                      Number(item.qty) * Number(item.rate);

                                    return (
                                      <tr key={item.id}>
                                        <td className="fw-semibold">
                                          {index + 1}
                                        </td>

                                        <td
                                          style={{
                                            maxWidth: "300px",
                                            whiteSpace: "normal",
                                            wordBreak: "break-word",
                                          }}
                                        >
                                          <div className="fw-semibold text-dark">
                                            {item.description}
                                          </div>
                                        </td>

                                        <td className="text-center">
                                          <span className="badge bg-light text-dark border">
                                            {item.qty}
                                          </span>
                                        </td>

                                        <td className="text-end">
                                          ₹ {Number(item.rate).toLocaleString()}
                                        </td>

                                        <td className="text-end">
                                          ₹{" "}
                                          {(
                                            Number(
                                              proposalDetails?.Proposal
                                                .total_tax
                                            ) /
                                            proposalDetails?.ItemDetails.length
                                          ).toLocaleString(undefined, {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2,
                                          })}
                                        </td>

                                        <td className="text-end fw-bold text-success">
                                          ₹ {amount.toLocaleString()}
                                        </td>
                                      </tr>
                                    );
                                  }
                                )}
                              </tbody>
                            </table>
                          </div>

                          <hr />
                          <div className="row">
                            <div className="col-md-8">
                              <label className="form-label fw-bold">
                                Terms & Conditions
                              </label>

                              <Input.TextArea
                                rows={20}
                                value={terms}
                                onChange={(e) => setTerms(e.target.value)}
                                placeholder="Enter payment terms and conditions..."
                              />
                            </div>

                            {/* Totals */}
                            <div className="col-md-4 d-flex justify-content-end">
                              <table
                                className="table text-end"
                                style={{ height: 200 }}
                              >
                                <tbody>
                                  <tr>
                                    <td>Sub Total</td>
                                    <td>
                                      ₹{" "}
                                      {Number(
                                        proposalDetails?.Proposal.subtotal
                                      ).toLocaleString()}
                                    </td>
                                  </tr>

                                  <tr>
                                    <td>Total Tax</td>
                                    <td>
                                      ₹{" "}
                                      {Number(
                                        proposalDetails?.Proposal.total_tax
                                      ).toLocaleString()}
                                    </td>
                                  </tr>

                                  <tr>
                                    <td>Adjustment</td>
                                    <td>
                                      ₹{" "}
                                      {Number(
                                        proposalDetails?.Proposal.adjustment
                                      ).toLocaleString()}
                                    </td>
                                  </tr>

                                  <tr className="table-primary bg-light">
                                    <td>Total</td>
                                    <td>
                                      ₹{" "}
                                      {Number(
                                        proposalDetails?.Proposal.total
                                      ).toLocaleString()}
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Right side content */}
                    </div>
                  </div>
                  <div
                    className={`tab-pane fade ${
                      activeTab === "comments" ? "show active" : ""
                    }`}
                    id="comments-tab-pane"
                    role="tabpanel"
                    aria-labelledby="comments-tab"
                  >
                    <div>
                      <div className="mb-3 mt-1 col-12">
                        <label></label>
                        <textarea
                          className="form-control"
                          placeholder="Add Comments"
                        ></textarea>
                        <div className="mt-2 d-flex justify-content-end">
                          <button className="btn btn-primary">
                            Add Comment
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className={`tab-pane fade ${
                      activeTab === "tasks" ? "show active" : ""
                    }`}
                    id="tasks-tab-pane"
                    role="tabpanel"
                    aria-labelledby="tasks-tab"
                  >
                    {/* <div className="d-flex justify-content-start">
                      <button className="btn  btn-primary">
                        <i className="fas fa-plus me-1"></i>New Task
                      </button>
                    </div> */}
                    <div className="pt-3">
                      <div className="card table-list-card">
                        <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                          <div className="search-set"></div>
                          <div className="d-flex table-dropdown my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                            <div className="dropdown me-2">
                              {/* <Link
                                to="#"
                                className="btn btn-white btn-md d-inline-flex align-items-center"
                                data-bs-toggle="modal"
                                data-bs-target="#add-units"
                              >
                                <i className="ti ti-filter me-1"></i>
                              </Link> */}
                            </div>
                            <div className="d-flex justify-content-end">
                              <button className="btn  btn-success">
                                <i className="fas fa-plus me-1"></i>
                              </button>
                            </div>
                          </div>
                        </div>

                        <div className="card-body">
                          <div className=" table-responsive">
                            <Table
                              columns={taskColumns}
                              dataSource={tasks}
                              loading={taskLoading}
                              rowKey="id"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className={`tab-pane fade ${
                      activeTab === "reminders" ? "show active" : ""
                    }`}
                    id="reminders-tab-pane"
                    role="tabpanel"
                    aria-labelledby="reminders-tab"
                  >
                    <>
                      <div className="container">
                        {editingReminderId === null && (
                          <>
                            <div className="row align-items-end g-2 pt-2">
                              <div className="col-md-5">
                                <Input.TextArea
                                  rows={2}
                                  // autoSize={{ minRows: 1, maxRows: 2 }}
                                  placeholder="Reminder description"
                                  value={reminderData.description}
                                  onChange={(e) =>
                                    setReminderData((prev) => ({
                                      ...prev,
                                      description: e.target.value,
                                    }))
                                  }
                                />
                              </div>

                              <div className="col-md-3">
                                <DatePicker
                                  showTime
                                  className="w-100"
                                  style={{ height: 38 }}
                                  value={reminderData.date}
                                  onChange={(value) =>
                                    setReminderData((prev) => ({
                                      ...prev,
                                      date: value,
                                    }))
                                  }
                                  suffixIcon={<CalendarOutlined />}
                                />
                              </div>

                              <div className="col-md-3">
                                <TagSelector
                                  className="w-100"
                                  style={{ height: 38 }}
                                  placeholder="Select Staff"
                                  loading={staffLoading}
                                  value={reminderData.staff}
                                  onChange={(value) =>
                                    setReminderData((prev) => ({
                                      ...prev,
                                      staff: value,
                                    }))
                                  }
                                  showSearch
                                  optionFilterProp="label"
                                  options={staffList.map((staff) => ({
                                    value: staff.staffid,
                                    label: `${staff.firstname} ${staff.lastname}`,
                                  }))}
                                />
                              </div>

                              <div className="col-md-1">
                                <button
                                  className="btn btn-primary w-100"
                                  onClick={handleAddReminder}
                                  disabled={addReminderLoading}
                                >
                                  {addReminderLoading ? "..." : "Add"}
                                </button>
                              </div>
                            </div>
                          </>
                        )}
                        {remindersLoading ? (
                          <div className="text-center py-4">
                            <Spin />
                          </div>
                        ) : reminders.length > 0 ? (
                          reminders.map((reminder) => (
                            <div
                              className="card shadow-sm border-0 mt-3"
                              key={reminder.id}
                            >
                              <div className="card-body">
                                {editingReminderId === reminder.id ? (
                                  <>
                                    <Input.TextArea
                                      rows={4}
                                      value={editReminderData.description}
                                      onChange={(e) =>
                                        setEditReminderData((prev) => ({
                                          ...prev,
                                          description: e.target.value,
                                        }))
                                      }
                                    />

                                    <DatePicker
                                      showTime
                                      className="w-100 mt-3"
                                      value={editReminderData.date}
                                      onChange={(value) =>
                                        setEditReminderData((prev) => ({
                                          ...prev,
                                          date: value,
                                        }))
                                      }
                                      suffixIcon={<CalendarOutlined />}
                                    />

                                    <div className="text-end mt-3">
                                      <button
                                        className="btn btn-light me-2"
                                        onClick={handleCancelReminderEdit}
                                      >
                                        Cancel
                                      </button>

                                      <button
                                        className="btn btn-primary"
                                        onClick={handleUpdateReminder}
                                        disabled={updateReminderLoading}
                                      >
                                        {updateReminderLoading
                                          ? "Updating..."
                                          : "Update"}
                                      </button>
                                    </div>
                                  </>
                                ) : (
                                  <>
                                    <p>{reminder.description}</p>

                                    <div className="d-flex justify-content-between align-items-center">
                                      <div>
                                        <small className="text-muted me-3">
                                          <i className="fa fa-user me-2"></i>
                                          {`${reminder.firstname} ${reminder.lastname}`}
                                        </small>

                                        <small className="text-muted">
                                          <i className="fa fa-calendar me-2"></i>
                                          {dayjs(reminder.date).format(
                                            "DD-MM-YYYY hh:mm A"
                                          )}
                                        </small>
                                      </div>

                                      <button
                                        className="btn btn-sm btn-outline-primary"
                                        onClick={() =>
                                          handleEditReminder(reminder)
                                        }
                                      >
                                        <i className="fa fa-edit me-1"></i>
                                        Edit
                                      </button>
                                    </div>
                                  </>
                                )}
                              </div>
                            </div>
                          ))
                        ) : (
                          <Empty description="No reminders found" />
                        )}
                      </div>
                    </>
                  </div>
                  <div
                    className={`tab-pane fade ${
                      activeTab === "notes" ? "show active" : ""
                    }`}
                    id="notes-tab-pane"
                    role="tabpanel"
                    aria-labelledby="notes-tab"
                  >
                    <div className="container mt-1">
                      <div className="row">
                        {notesLoading ? (
                          <div className="text-center py-3">
                            <Spin />
                          </div>
                        ) : (
                          <>
                            {/* Add Note Form */}
                            {editingNoteId === null && (
                              <>
                                <div className="col-12 mb-3 pt-2">
                                  <textarea
                                    className="form-control"
                                    rows="5"
                                    placeholder="Enter your note here..."
                                    value={noteData.description}
                                    onChange={(e) =>
                                      setNoteData((prev) => ({
                                        ...prev,
                                        description: e.target.value,
                                      }))
                                    }
                                  />
                                </div>

                                <div className="col-12 text-end mb-3">
                                  <button
                                    className="btn btn-primary"
                                    onClick={handleAddNote}
                                    disabled={addNoteLoading}
                                  >
                                    {addNoteLoading ? (
                                      <>
                                        <span className="spinner-border spinner-border-sm me-2"></span>
                                        Adding...
                                      </>
                                    ) : (
                                      "Add Note"
                                    )}
                                  </button>
                                </div>
                              </>
                            )}

                            {/* Notes List or Empty */}
                            {notes.length > 0 ? (
                              <div className="mt-2">
                                {notes.map((note) => (
                                  <div
                                    key={note.id}
                                    className="card border-0 shadow-sm mb-3"
                                  >
                                    <div className="card-body">
                                      {editingNoteId === note.id ? (
                                        <>
                                          <textarea
                                            rows={4}
                                            className="form-control mb-3"
                                            value={editNoteData.description}
                                            onChange={(e) =>
                                              setEditNoteData({
                                                description: e.target.value,
                                              })
                                            }
                                          />

                                          <div className="d-flex justify-content-end gap-2">
                                            <button
                                              className="btn btn-light"
                                              onClick={handleCancelEdit}
                                              disabled={updateNoteLoading}
                                            >
                                              Cancel
                                            </button>

                                            <button
                                              className="btn btn-primary"
                                              onClick={handleUpdateNote}
                                              disabled={updateNoteLoading}
                                            >
                                              {updateNoteLoading ? (
                                                <>
                                                  <span className="spinner-border spinner-border-sm me-2"></span>
                                                  Updating...
                                                </>
                                              ) : (
                                                "Update"
                                              )}
                                            </button>
                                          </div>
                                        </>
                                      ) : (
                                        <>
                                          <div className="d-flex justify-content-between">
                                            <p className="mb-2">
                                              {note.description}
                                            </p>
                                            <button
                                              className="btn btn-sm btn-outline-secondary btn-icon"
                                              onClick={() =>
                                                handleEditNote(note)
                                              }
                                            >
                                              <i className="fa-solid fa-pen-to-square"></i>
                                            </button>
                                          </div>

                                          <div className="d-flex justify-content-between align-items-center">
                                            <div>
                                              <small className="text-muted me-3">
                                                <i className="fa-regular fa-user me-2"></i>
                                                {note.added_by_name}
                                              </small>

                                              <small className="text-muted">
                                                <i className="fa-regular fa-calendar me-2"></i>
                                                {dayjs(note.dateadded).format(
                                                  "DD-MM-YYYY hh:mm A"
                                                )}
                                              </small>
                                            </div>
                                          </div>
                                        </>
                                      )}
                                    </div>
                                  </div>
                                ))}
                              </div>
                            ) : (
                              <div className="col-12">
                                <Empty description="No notes found" />
                              </div>
                            )}
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                  <div
                    className={`tab-pane fade ${
                      activeTab === "templates" ? "show active" : ""
                    }`}
                    id="templates-tab-pane"
                    role="tabpanel"
                    aria-labelledby="templates-tab"
                  >
                    <Link
                      className="btn btn-primary"
                      data-bs-toggle="offcanvas"
                      data-bs-target="#offcanvasAddTemplate"
                    >
                      Add Template
                    </Link>
                    <hr />
                  </div>

                  <div
                    className={`tab-pane fade ${
                      activeTab === "mail" ? "show active" : ""
                    }`}
                    id="mail-tab-pane"
                    role="tabpanel"
                    aria-labelledby="mail-tab"
                  >
                    <h5 className="mb-2">Tracked Email Sent</h5>
                    <div className="card table-list-card ">
                      <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                        <div className="search-set"></div>
                        <div className="d-flex table-dropdown my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                          <div className="dropdown me-2">
                            <Link
                              to="#"
                              className="btn btn-white btn-md d-inline-flex align-items-center"
                              data-bs-toggle="modal"
                              data-bs-target="#add-units"
                            >
                              <i className="ti ti-filter me-1"></i>
                            </Link>
                          </div>
                        </div>
                      </div>

                      <div className="card-body">
                        <div className=" table-responsive">
                          <Table
                            columns={[
                              { title: "Date" },
                              { title: "Subject" },
                              { title: "To" },
                              { title: "Opened" },
                            ]}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* 
                  <div
                    className={`tab-pane fade ${
                      activeTab === "view" ? "show active" : ""
                    }`}
                    id="view-tab-pane"
                    role="tabpanel"
                    aria-labelledby="view-tab"
                  >
                    <h5 className="text-success">Date:25/03/2025 12:45:21</h5>
                    <h5>IP Address: </h5>
                    <hr/>
                  </div> */}
                </div>
              </div>
            </div>
          </div>

          <Drawer
            title="Notes"
            open={noteDrawerOpen}
            onClose={() => setNoteDrawerOpen(false)}
            width={500}
            maskClosable={true}
            destroyOnClose
            closable={false}
            extra={
              <Button
                type="text"
                icon={<CloseOutlined />}
                onClick={() => setNoteDrawerOpen(false)}
              />
            }
          >
            <div className="container">
              <div className="row">
                {notesLoading ? (
                  <div className="text-center">
                    <Spin />
                  </div>
                ) : (
                  <>
                    {/* Add Note Form */}
                    {editingNoteId === null && (
                      <>
                        <div className="col-12 mb-2">
                          <textarea
                            className="form-control"
                            rows="3"
                            placeholder="Enter your note here..."
                            value={noteData.description}
                            onChange={(e) =>
                              setNoteData((prev) => ({
                                ...prev,
                                description: e.target.value,
                              }))
                            }
                          />
                        </div>

                        <div className="col-12 text-end mb-2">
                          <button
                            className="btn btn-primary"
                            onClick={handleAddNote}
                            disabled={addNoteLoading}
                          >
                            {addNoteLoading ? (
                              <>
                                <span className="spinner-border spinner-border-sm me-2"></span>
                                Adding...
                              </>
                            ) : (
                              "Add Note"
                            )}
                          </button>
                        </div>
                      </>
                    )}

                    {/* Notes List or Empty */}
                    {notes.length > 0 ? (
                      <div className="mt-2">
                        {notes.map((note) => (
                          <div
                            key={note.id}
                            className="card border-0 shadow mb-3"
                          >
                            <div className="card-body">
                              {editingNoteId === note.id ? (
                                <>
                                  <textarea
                                    rows={4}
                                    className="form-control mb-3"
                                    value={editNoteData.description}
                                    onChange={(e) =>
                                      setEditNoteData({
                                        description: e.target.value,
                                      })
                                    }
                                  />

                                  <div className="d-flex justify-content-end gap-2">
                                    <button
                                      className="btn btn-light"
                                      onClick={handleCancelEdit}
                                      disabled={updateNoteLoading}
                                    >
                                      Cancel
                                    </button>

                                    <button
                                      className="btn btn-primary"
                                      onClick={handleUpdateNote}
                                      disabled={updateNoteLoading}
                                    >
                                      {updateNoteLoading ? (
                                        <>
                                          <span className="spinner-border spinner-border-sm me-2"></span>
                                          Updating...
                                        </>
                                      ) : (
                                        "Update"
                                      )}
                                    </button>
                                  </div>
                                </>
                              ) : (
                                <>
                                  <div className="d-flex justify-content-between">
                                    <p className="mb-2">{note.description}</p>
                                    <button
                                      className="btn btn-sm btn-outline-secondary btn-icon"
                                      onClick={() => handleEditNote(note)}
                                    >
                                      <i className="fa-solid fa-pen-to-square"></i>
                                    </button>
                                  </div>

                                  <div className="d-flex justify-content-between align-items-center">
                                    <div>
                                      <small className="text-muted me-3">
                                        <i className="fa-regular fa-user me-2"></i>
                                        {note.added_by_name}
                                      </small>

                                      <small className="text-muted">
                                        <i className="fa-regular fa-calendar me-2"></i>
                                        {dayjs(note.dateadded).format(
                                          "DD-MM-YYYY hh:mm A"
                                        )}
                                      </small>
                                    </div>
                                  </div>
                                </>
                              )}
                            </div>
                          </div>
                        ))}
                      </div>
                    ) : (
                      <div className="col-12">
                        <Empty description="No notes found" />
                      </div>
                    )}
                  </>
                )}
              </div>
            </div>
          </Drawer>

          <Drawer
            title="Reminders"
            open={reminderDrawerOpen}
            onClose={handleCloseReminderDrawer}
            width={550}
            destroyOnClose
            maskClosable={true}
            closable={false}
            extra={
              <Button
                type="text"
                icon={<CloseOutlined />}
                onClick={() => setReminderDrawerOpen(false)}
              />
            }
          >
            {/* Add / Edit Form */}

            {editingReminderId === null ? (
              <>
                <Input.TextArea
                  rows={3}
                  placeholder="Reminder description"
                  value={reminderData.description}
                  onChange={(e) =>
                    setReminderData((prev) => ({
                      ...prev,
                      description: e.target.value,
                    }))
                  }
                />

                <div className="row mt-3">
                  <div className="col-md-6">
                    <DatePicker
                      showTime
                      className="w-100"
                      value={reminderData.date}
                      onChange={(value) =>
                        setReminderData((prev) => ({
                          ...prev,
                          date: value,
                        }))
                      }
                    />
                  </div>

                  <div className="col-md-6">
                    <TagSelector
                      className="w-100"
                      style={{ height: 38 }}
                      placeholder="Select Staff"
                      loading={staffLoading}
                      value={reminderData.staff}
                      onChange={(value) =>
                        setReminderData((prev) => ({
                          ...prev,
                          staff: value,
                        }))
                      }
                      options={staffList.map((staff) => ({
                        value: staff.staffid,
                        label: `${staff.firstname} ${staff.lastname}`,
                      }))}
                    />
                  </div>
                </div>

                <div className="text-end mt-3">
                  <Button
                    type="primary"
                    loading={addReminderLoading}
                    onClick={handleAddReminder}
                  >
                    Add
                  </Button>
                </div>
              </>
            ) : (
              <>
                {/* Edit Form */}
                <Input.TextArea
                  rows={3}
                  value={editReminderData.description}
                  onChange={(e) =>
                    setEditReminderData((prev) => ({
                      ...prev,
                      description: e.target.value,
                    }))
                  }
                />
                <div className="row mt-3">
                  <div className="col-md-6">
                    <DatePicker
                      showTime
                      className="w-100 mt-3"
                      value={editReminderData.date}
                      onChange={(value) =>
                        setEditReminderData((prev) => ({
                          ...prev,
                          date: value,
                        }))
                      }
                    />
                  </div>
                  <div className="col-md-6">
                    <TagSelector
                      className="w-100 mt-3"
                      style={{ height: 38 }}
                      value={editReminderData.staff}
                      onChange={(value) =>
                        setEditReminderData((prev) => ({
                          ...prev,
                          staff: value,
                        }))
                      }
                      options={staffList.map((staff) => ({
                        value: staff.staffid,
                        label: `${staff.firstname} ${staff.lastname}`,
                      }))}
                    />
                  </div>
                </div>
                <div className="text-end mt-3">
                  <Button className="me-2" onClick={handleCancelReminderEdit}>
                    Cancel
                  </Button>

                  <Button
                    type="primary"
                    loading={updateReminderLoading}
                    onClick={handleUpdateReminder}
                  >
                    Update
                  </Button>
                </div>
              </>
            )}

            <Divider>Reminder List</Divider>

            {remindersLoading ? (
              <div className="text-center py-4">
                <Spin />
              </div>
            ) : reminders.length > 0 ? (
              reminders.map((reminder) => (
                <Card key={reminder.id} size="small" className="mb-3 shadow">
                  <div className="d-flex justify-content-between">
                    <div>
                      <div>{reminder.description}</div>

                      <div className="d-flex align-items-center gap-3 text-muted mt-2">
                        <small>
                          <i className="fa fa-user me-2"></i>
                          {reminder.firstname} {reminder.lastname}
                        </small>

                        <small>
                          <i className="fa fa-calendar me-2"></i>
                          {dayjs(reminder.date).format("DD-MM-YYYY hh:mm A")}
                        </small>
                      </div>
                    </div>

                    <Button
                      type="text"
                      icon={<EditOutlined />}
                      onClick={() => handleEditReminder(reminder)}
                    />
                  </div>
                </Card>
              ))
            ) : (
              <Empty description="No reminders found" />
            )}
          </Drawer>
          <SetProposalReminder />
          <AddTemplate />
        </div>
      </div>
    </>
  );
};

export default ProposalInfo;
